import { useEffect } from 'react'

export default function useHandleTrackPublicationFailed(room, onError) {
    const { localParticipant } = room
    useEffect(() => {
        if (localParticipant) {
            localParticipant.addListener('trackPublicationFailed', onError)
            return () => {
                localParticipant.removeListener(
                    'trackPublicationFailed',
                    onError
                )
            }
        }
    }, [localParticipant, onError])
}
